import React from 'react';
import Player from './_Player';
import { captureException } from '@sentry/nextjs';

interface Props {
  isPlaying: boolean;
  isStopped?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  animationUrl: string;
}

const LottiePlayer = ({
  animationUrl,
  isPlaying,
  isStopped = false,
  loop = false,
  autoplay = false,
}: Props) => {
  const [animationData, setAnimationData] = React.useState(null);

  React.useEffect(() => {
    fetch(animationUrl, {
      method: 'GET',
      mode: 'cors',
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setAnimationData(data);
      })
      .catch((e) => {
        captureException(e, {
          extra: {
            animationUrl,
            message: e.message,
          },
        });
      });
  }, [animationUrl]);

  return (
    <div 
      className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-[2] tw-pointer-events-none [&_.lf-player-container]:tw-w-full [&_.lf-player-container]:tw-h-full" 
      aria-hidden={true}
    >
      {animationData && !isStopped && (
        <Player
          animationData={animationData}
          isPlaying={isPlaying}
          autoplay={autoplay}
          loop={loop}
        />
      )}
    </div>
  );
};

export default LottiePlayer;
